module.exports = __webpack_public_path__ + "images/emoji/train.d7490d51f2aedb69a9f5.png";